import { useQuery } from '@tanstack/react-query';
import { fetchConfig } from '@/api/trip';
import { tripKeys } from '@/api/queryKeys';

/**
 * Zentraler Hook für die Trip-Konfiguration (Trip-Meta + VAPID + Feature-Flags).
 * Wird von AuthPage, HomePage, PlanPage und allen Folge-Pages konsumiert —
 * dank TanStack-Query-Cache wird `/api/config` pro Trip nur einmal pro
 * staleTime-Fenster gefetcht, egal wie viele Components ihn nutzen.
 */
export function useTrip(slug: string) {
  return useQuery({
    queryKey: tripKeys.config(slug),
    queryFn: ({ signal }) => fetchConfig(slug, signal),
    staleTime: 5 * 60_000,
  });
}
